module.exports = __webpack_public_path__ + "assets/img/fuzhang_2.69894767.png";